import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from '@cropler/ui-kit';

import styles from '../../styles/auth.module.scss';

import { AuthTitle } from '../../components';
import type { RootState } from '../../store';

const ConfirmEmail = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { username } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (!username) {
      navigate('/login');
    }
  }, [username, navigate]);

  return (
    <>
      <div className={styles.formContainer}>
        <div className={styles.form}>
          <AuthTitle title={t('login.titleConfirm')} withBackButton />
          <p className={styles.description}>
            <Trans
              i18nKey="login.textConfirm"
              values={{ username: username }}
              components={{
                span1: <span className={styles.email} />,
                nowrap: <span className={'nowrap'} />,
              }}
            />
          </p>
          <Button
            type="primary"
            className={styles.buttonSubmit}
            size={'large'}
            onClick={() => navigate('/reset-password')}
          >
            {t('actions.setPassword')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default ConfirmEmail;
